export const REJECTION_REASON_MAX_LENGTH = 1000;

export const REJECT_CONDITION_FORM_ID = 'reject-condition-form';
